import { createContext, useContext } from 'react'
import { roleNameMap } from '@/stores/view-role'

export interface TaskAssignee { id?: string | null; name?: string | null; role?: string | null }
const roleName = (role?: string | null) => role ? (roleNameMap as Record<string, string>)[role] || role : '部门'
export const assigneeText = (person: TaskAssignee) => person.name || (person.id ? `人员 ${person.id}` : `${roleName(person.role)}（共享待办）`)
export const TaskAssigneeContext = createContext<string | null>(null)
export const TaskKindContext = createContext<string>('')

/** Display responsibility from the existing assignment, never from the viewing account. */
export function taskAssigneeText(row: any, kind: string): string {
  row ??= {}
  if (['payment-claim', 'refund-approval', 'reissue-approval'].includes(kind) || kind === 'invoice-approval' && row.taskId) {
    return assigneeText({ id: row.assigneeId, name: row.assigneeName, role: row.assigneeRole || 'MARKET' })
  }
  if (['dispatch', 'mail-receive', 'mail-dispatch', 'mail-return', 'outsource-testing', 'cert', 'mail-workbench'].includes(kind)) {
    return row.serviceAssignees?.length ? row.serviceAssignees.map(assigneeText).join('、') : assigneeText({ role: 'SERVICE' })
  }
  if (['inspect-onsite', 'inspect-mail'].includes(kind)) return assigneeText({ id: row.engineerId, name: row.engineerName, role: kind === 'inspect-mail' ? 'LAB_ENGINEER' : 'ENGINEER' })
  if (['invoice-approval', 'voucher-assist'].includes(kind)) return assigneeText({ id: row.salespersonId, name: row.salespersonName, role: 'MARKET' })
  if (['issue-invoice', 'voucher-audit', 'receipt-register', 'payment-reconcile', 'refund'].includes(kind)) return assigneeText({ role: 'FINANCE' })
  if (kind === 'monthly') return '所属公司月结管理员（共享待办）'
  if (kind === 'customer') return row.customerName || row.customer?.name || '下单客户'
  return assigneeText({ role: 'MARKET' })
}

export function TaskAssigneeNotice({ text }: { text?: string | null }) {
  const context = useContext(TaskAssigneeContext)
  const value = text ?? context
  return value ? <div className="mb-3 rounded border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">应处理人：{value}</div> : null
}
